module.exports = __webpack_public_path__ + "e621e0ad032ff7734907546f5f8e6f18.svg";